import GenericsServices from "../services/generics";
const Generics = {
  install: function (Vue, options) {
    Vue.prototype.$services = GenericsServices;
  },
};

export default Generics;
